import React, { useRef, useEffect, useState } from "react";
import Select from "react-select";

const ByDefaultSelected = ({
  options,
  selectedOption,
  setSelectedOption,
  name,
  closeSelect,
  ...props
}) => {
  const [isClient, setIsClient] = useState(false);
  const dateRangeRef = useRef();

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (!isClient) return;

    const handleClickOutside = (event) => {
      if (
        closeSelect &&
        dateRangeRef.current &&
        !dateRangeRef.current.contains(event.target)
      ) {
        closeSelect();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isClient, closeSelect]);

  useEffect(() => {
    if (options && options.length > 0 && !selectedOption) {
      setSelectedOption(options[0]);
    }
  }, [options, selectedOption, setSelectedOption]);

  return (
    <div
      ref={dateRangeRef}
      style={{ width: "100%", height: "100%", minWidth: "100%" }}
    >
      {isClient && (
        <Select
          value={selectedOption || options[0]}
          // value={
          //   options.find((option) => option.value === selectedOption.value) ||
          //   options[0]
          // }
          {...props}
          onChange={setSelectedOption}
          options={options || []}
          placeholder={`Select ${name}`}
          isClearable
          isSearchable
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        />
      )}
    </div>
  );
};

export default ByDefaultSelected;
